import { createContext } from "react";
var CheckoutContext = /*#__PURE__*/createContext(undefined);
export default CheckoutContext;